import { Flex } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import moment from 'moment';

import { TextBold, TextRegular } from 'UiKit/typography';
import BadgeEcomerce from 'Component/badge-ecommerce';

import AttachmentImage from 'Component/attachment-image';
import { modalDetailWinnerText } from 'Const/brief-live/view';

import styles from './styles.module.css';
import { Condition } from 'Component/others';

const tableList = (onOpenPreview) => [
  {
    name: modalDetailWinnerText.columnPicture,
    key: 'images',
    position: 'left',
    width: '90px',
    component: ({ value }) => {
      const images = value ? value.map((image) => ({ url: image })) : [];
      return (
        <Box className={styles['modal__table--col-image']}>
          <AttachmentImage images={images} onOpenPreview={onOpenPreview} />
        </Box>
      );
    },
  },
  {
    name: modalDetailWinnerText.columnUpdatedAt,
    key: 'createdAt',
    position: 'left',
    width: '150px',
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{moment(value).format('DD MMM YY | HH:mm') || '-'}</TextRegular>;
    },
  },
  {
    name: modalDetailWinnerText.columnStockUsed,
    key: 'usedStock',
    position: 'center',
    width: '90px',
    customizeTableHead: (
      <TextBold textTransform="capitalize" whiteSpace="wrap" textAlign="center">
        {modalDetailWinnerText.columnStockUsed}
      </TextBold>
    ),
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value}</TextRegular>;
    },
  },
  {
    name: modalDetailWinnerText.columnWinnerInfo,
    key: 'note',
    position: 'left',
    width: '155px',
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value || '-'}</TextRegular>;
    },
  },
  {
    name: modalDetailWinnerText.columnHost,
    key: 'host',
    position: 'left',
    width: '150px',
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value || '-'}</TextRegular>;
    },
  },
  {
    name: modalDetailWinnerText.columnGiveawayDuration,
    key: 'giveawayDuration',
    position: 'left',
    width: '150px',
    component: ({ value }) => {
      return (
        <Flex direction={'column'}>
          <TextRegular className={`${styles['modal__table--col-text']}`}>{value?.startDate} -</TextRegular>
          <TextRegular className={`${styles['modal__table--col-text']}`}>{value?.endDate}</TextRegular>
        </Flex>
      );
    },
  },
  {
    name: modalDetailWinnerText.columnAccount,
    key: 'account',
    position: 'left',
    width: '250px',
    component: ({ value }) => {
      return (
        <Condition statement={value} fallback={<TextRegular className={`${styles['modal__table--col-text']}`}>-</TextRegular>}>
          <BadgeEcomerce accountName={value?.accountName} ecommerce={value?.ecommerce} />
        </Condition>
      );
    },
  },
];
export default tableList;
